import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import Hero from "@/components/ui/Hero";
import CTABlock from "@/components/ui/CTABlock";
import CompletedWorkGrid from "@/components/ui/CompletedWorkGrid";
import Reveal from "@/components/ui/Reveal";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { BUSINESS } from "@/lib/constants";

export default function Gallery() {
    useDocumentTitle(
        "A1 Screening Project Gallery · Pool Cage & Screen Enclosure · Naples, FL",
        "Project photos from A1 Screening — a family-owned pool cage and screen enclosure company based in Naples and serving Southwest Florida."
    );
    return (
        <>
            <Hero
                eyebrow="Project Photos"
                title="A1 Screening Project Gallery"
                subtitle="Pool cage and screen enclosure project photos from A1 Screening. Photos are shown as project examples — not as before-and-after comparisons."
                primaryCta={{ to: "/free-estimate", label: "Request a Free Estimate" }}
            />
            <section className="a1-section">
                <div className="a1-container">
                    <Reveal>
                        <div className="max-w-3xl mb-10">
                            <p className="a1-eyebrow mb-3">A1 Screening Project Photos</p>
                            <h2 className="mb-4 a1-h2-underline">Pool Cage & Screen Enclosure Project Photos</h2>
                            <p className="text-lg leading-relaxed" style={{ color: "var(--color-text-muted)" }}>
                                Each photo below is from a real A1 Screening pool cage or screen enclosure project. Final recommendations and pricing are confirmed after technician review.
                            </p>
                        </div>
                    </Reveal>
                    <CompletedWorkGrid surface="gallery" layout="editorial" />
                    <Reveal delay={120}>
                        <p className="a1-helper mt-8 text-center">
                            Photos are shown as project examples. Specific service type and exact location are not stated for each photo unless confirmed by A1 Screening.
                        </p>
                    </Reveal>
                </div>
            </section>

            {/* CTA strip */}
            <section className="a1-bg-alt a1-section">
                <div className="a1-container max-w-3xl text-center">
                    <p className="a1-eyebrow mb-3 justify-center" style={{ display: "inline-flex" }}>Ready to Start?</p>
                    <h2 className="mb-5 a1-h2-underline">Get a Free Estimate on Your Pool Cage</h2>
                    <p className="text-lg leading-relaxed mb-8" style={{ color: "var(--color-text-muted)" }}>
                        Send us a few photos or call — we'll give you a free written estimate. Family-owned and serving Southwest Florida since 1999.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Link to="/free-estimate" className="a1-btn-primary" data-testid="gallery-cta-quote">
                            Request a Free Estimate <ArrowRight size={18} />
                        </Link>
                        <a
                            href={`tel:${BUSINESS.phoneTel}`}
                            className="a1-btn-secondary"
                            data-testid="gallery-cta-call"
                        >
                            <Phone size={18} strokeWidth={2.5} /> Call {BUSINESS.phone}
                        </a>
                    </div>
                </div>
            </section>

            <CTABlock />
        </>
    );
}
